import { InjectionToken } from '@angular/core';
/**
 * @hidden
 */
export var NAVIGATION_CONFIG = new InjectionToken('navigation.config');



//////////////////
// WEBPACK FOOTER
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/~/@progress/kendo-angular-buttons/dist/es/navigation/navigation-config.js
// module id = ../../../../@progress/kendo-angular-buttons/dist/es/navigation/navigation-config.js
// module chunks = 3